export default function uppercaseFirst(string) {
  if (!string) return null
  return `${string.charAt(0).toUpperCase()}${string.substring(1)}`
}
